import React, { Component, Fragment } from 'react'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import Undo from 'material-ui/svg-icons/content/undo'
import CircularProgress from '@material-ui/core/CircularProgress'
import ActionDelete from 'material-ui/svg-icons/action/delete'
import IconButton from '@material-ui/core/IconButton'
import ImageEdit from 'material-ui/svg-icons/image/edit'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import { connect } from 'react-redux'
import TablePagination from '@material-ui/core/TablePagination'
import { keywordsActions, confirmActions, messageActions } from '../../actions'
import jwt_decode from 'jwt-decode'
import Typography from '@material-ui/core/Typography'
import { listTableStyle } from '../../styles'
import { reloadTable } from '../../utils/reloadTable'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import { findPermission, readOnly } from '../../utils/permissions'
import Visibility from '@material-ui/icons/Visibility'

class ListTable extends Component {
  state = {
    debounce: undefined
  }

  componentWillUpdate(newProps) {
    const { pagination, order, fetchKeywords, term } = newProps
    const { page, rowsPerPage: perPage } = pagination

    if (reloadTable(newProps, this.props)) {
      const debounce = setTimeout(() => {
        fetchKeywords({ page, perPage, order, term })
      }, 700)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }

    return true
  }
  componentDidMount() {
    const { fetchKeywords, changeOrderColumn, order, term } = this.props
    fetchKeywords()
  }

  renderActions = item => {
    const { fetchKeyword, deleteKeyword, addConfirm, token, restoreKeyword } = this.props

    return (
      <Fragment>
        {readOnly('palavrasChave', token) &&
          !item.deletedAt && (
            <IconButton
              onClick={() => {
                fetchKeyword(item._id)
              }}
            >
              <Visibility nativeColor={'rgba(0, 0, 0, 0.87)'} />
            </IconButton>
          )}

        {!!item.deletedAt && findPermission('palavrasChave', token).remover ? (
          <IconButton
            onClick={() => {
              const { changeMessage } = this.props

              addConfirm({
                confirmMessage: 'Confirma a restauração desta palavra-chave?',
                confirmFunction: () => {
                  restoreKeyword(item._id)
                  changeMessage({ message: 'Restauração realizada com sucesso.' })
                }
              })
            }}
          >
            <Undo />
          </IconButton>
        ) : (
          <Fragment>
            {findPermission('palavrasChave', token).editar && (
              <IconButton
                onClick={() => {
                  fetchKeyword(item._id)
                }}
              >
                <ImageEdit />
              </IconButton>
            )}

            {findPermission('palavrasChave', token).remover && (
              <IconButton
                onClick={() => {
                  const { changeMessage } = this.props

                  addConfirm({
                    confirmMessage: 'Confirma a exclusão desta palavra-chave?',
                    confirmFunction: () => {
                      deleteKeyword(item._id)
                      changeMessage({ message: 'Exclusão realizada com sucesso.' })
                    }
                  })
                }}
              >
                <ActionDelete />
              </IconButton>
            )}
          </Fragment>
        )}
      </Fragment>
    )
  }

  handleChangePage = (event, page) => {
    const { pagination, handleChangePage, fetchKeywords, order, term } = this.props
    handleChangePage(page)
  }

  handleChangeRowsPerPage = event => {
    const perPage = event.target.value
    const { pagination, fetchKeywords, handleChangePerPage, order, term } = this.props
    handleChangePerPage(perPage)
  }

  handleSortTable = column => {
    const {
      order,
      changeOrderColumn,
      changeOrderDirection,
      fetchKeywords,
      pagination,
      term
    } = this.props

    const { page, rowsPerPage: perPage } = pagination

    if (column === ((order || {}).column || '')) {
      const direction = ((order || {}).direction || 1) === -1 ? 1 : -1
      changeOrderDirection(direction)
    } else {
      changeOrderColumn(column)
    }
  }

  render() {
    const {
      classes,
      keywords = [],
      loadingKeywords,
      addConfirm,
      restoreKeyword,
      pagination,
      order = {}
    } = this.props
    return (
      <Paper className={classes.wrapperTable} elevation={4}>
        {!!loadingKeywords && (
          <div className={classes.wrapperLoader}>
            <CircularProgress />
          </div>
        )}
        <Table
          fixedHeader={true}
          width={'990px'}
          wrapperStyle={{
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'var(--crud-table-height)'
          }}
        >
          <TableHeader
            displaySelectAll={false}
            className={classes.tableHeader}
            adjustForCheckbox={false}
          >
            <TableRow>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'nome'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('nome')
                  }}
                >
                  Palavra-chave
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'sinonimos'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('sinonimos')
                  }}
                >
                  Sinônimos
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '100px' }}>Ações</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false} className={classes.tableBody}>
            {(keywords || []).length ? (
              (keywords || []).map(content => {
                return (
                  <TableRow key={content._id}>
                    <TableRowColumn>{content.nome}</TableRowColumn>
                    <TableRowColumn>{content.sinonimos || '--'}</TableRowColumn>
                    <TableRowColumn style={{ width: '100px' }}>
                      {this.renderActions(content)}
                    </TableRowColumn>
                  </TableRow>
                )
              })
            ) : (
              <TableRow>
                <TableRowColumn>
                  <Typography noWrap style={{ textAlign: 'center', padding: '16px' }}>
                    {!!loadingKeywords ? 'Carregando...' : 'Não há registros.'}
                  </Typography>
                </TableRowColumn>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <div className={classes.paginationWrapper}>
          <div className={classes.page}>Página: {pagination.page + 1}</div>
          <TablePagination
            component="div"
            className={classes.pagination}
            labelRowsPerPage="Itens por página"
            labelDisplayedRows={({ from, to, count, page }) => {
              return `Exibindo de ${from} a ${to} de ${count}`
            }}
            count={pagination.length}
            rowsPerPage={pagination.rowsPerPage}
            rowsPerPageOptions={[25, 50, 100]}
            page={pagination.page}
            backIconButtonProps={{
              'aria-label': 'Página anterior'
            }}
            nextIconButtonProps={{
              'aria-label': 'Próxima página'
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </div>
      </Paper>
    )
  }
}

const mapStateToProps = state => {
  return {
    keyword: state.keywords.keyword,
    keywords: state.keywords.keywords,
    loadingKeywords: state.keywords.loadingKeywords,
    token: state.auth.token,
    pagination: state.keywords.keywordsPagination,
    order: state.keywords.order,
    term: state.searchTable.term
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(keywordsActions.openModal())
    },
    closeModal: () => {
      dispatch(keywordsActions.closeModal())
    },
    fetchKeyword: id => {
      dispatch(keywordsActions.fetchKeyword(id))
    },
    fetchKeywords: options => {
      dispatch(keywordsActions.fetchKeywords(options))
    },
    deleteKeyword: id => {
      dispatch(keywordsActions.deleteKeyword(id))
    },
    addConfirm: ({ confirmMessage, confirmFunction }) => {
      dispatch(confirmActions.addFunction({ confirmMessage, confirmFunction }))
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    restoreKeyword: id => {
      dispatch(keywordsActions.restoreKeyword(id))
    },
    handleChangePage: page => {
      dispatch(keywordsActions.handleChangePage(page))
    },
    handleChangePerPage: perPage => {
      dispatch(keywordsActions.handleChangePerPage(perPage))
    },
    changeOrderColumn: column => {
      dispatch(keywordsActions.changeOrderColumn(column))
    },
    changeOrderDirection: direction => {
      dispatch(keywordsActions.changeOrderDirection(direction))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(listTableStyle)(ListTable))



// WEBPACK FOOTER //
// ./src/containers/Keywords/ListTable.js